import { useCallback } from 'react';
import { Crown } from 'lucide-react';
import MappingList from '../../../components/MappingList';
import ImageWithFallback from '../../../components/ImageWithFallback';
import { listProductImages, createImage, updateImage, removeImage, uploadFile } from '../../../utils/queries';

const COLUMNS = [
	{
		key: 'imageUrl',
		header: 'Media',
		render: (value, row) =>
			row.mediaType === 'video' ? (
				<video src={value} className='h-10 w-10 object-cover rounded' muted />
			) : (
				<ImageWithFallback src={value} className='h-10 w-10 object-cover rounded' fallbackClassName='h-10 w-10 rounded' />
			),
	},
	{ key: 'imageUrl', header: 'URL' },
	{ key: 'mediaType', header: 'Type' },
	{ key: 'altText', header: 'Alt Text' },
	// The /products list thumbnail only ever shows the isPrimary image, so
	// make which one that is (and how to change it) visible here.
	{ key: 'isPrimary', header: 'Primary', render: (value) => (value ? <Crown size={20} className='text-green-600' /> : '') },
];
const ADD_FIELDS = [
	{ key: 'file', label: 'Image or Video File', type: 'file', accept: 'image/*,video/mp4,video/webm,video/quicktime', required: true },
	{ key: 'altText', label: 'Alt Text' },
];

const ROW_ACTIONS = [
	{
		label: 'Mark Primary',
		icon: Crown,
		hidden: (row) => row.isPrimary,
		onClick: (row) => updateImage(row.productImageId, { isPrimary: true }),
	},
];

export default function ImagesTab({ product }) {
	const list = useCallback(() => listProductImages(product.productId), [product.productId]);
	const add = useCallback(
		async (fields) => {
			const uploadResult = await uploadFile({
				file: fields.file,
				storeId: product.storeId,
				kind: 'product',
				productId: product.productId,
			});
			if (!uploadResult?.success) return uploadResult;
			// Persist the path (stable across port changes), not the resolved
			// preview `url` -- see uploads.controller.ts.
			return createImage(product.productId, {
				imageUrl: uploadResult.data.path,
				mediaType: uploadResult.data.mediaType,
				altText: fields.altText,
			});
		},
		[product.productId, product.storeId],
	);

	return (
		<MappingList
			list={list}
			add={add}
			remove={removeImage}
			columns={COLUMNS}
			addFields={ADD_FIELDS}
			rowActions={ROW_ACTIONS}
			idKey='productImageId'
			emptyHeading='No images yet'
			collapsibleAdd
		/>
	);
}
